import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "screen" }
const _hoisted_2 = { class: "box-login" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "btn btn-primary" }
const _hoisted_8 = { class: "recover" }

import store from "@/store";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { MD5 } from "crypto-js";
import { toast } from "@/common/utils/toast";
import { baseInput, svgIcon } from "@/common/components";

import { setUser } from "@/common/services/user";
import { userLogin, userProfile } from "@/common/api/rest/user";
import type { UserLoginType } from "@/common/types/user";


export default /*@__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();

const payload = ref<UserLoginType>({
  login: "",
  password: "",
});

const passwordShow = ref(false);
const error = ref<{ [key: string]: string }>({});

function goTo(url: string) {
  router.push(url);
}

function isValid() {
  const { login, password } = payload.value;

  error.value = {};

  if (login.trim().length === 0) error.value.login = t("error.required");

  if (password.trim().length === 0) error.value.password = t("error.required");

  return Object.keys(error.value).length === 0;
}

function fecthProfile() {
  userProfile().then((response) => {
    const { success, data, message } = response;
    if (success) {
      store.commit("SET_PROFILE", data);
      goTo("/home");
    } else {
      toast({ message: message, type: "error" });
    }
  });
}

function sendLogin() {
  if (!isValid()) return;

  userLogin({
    ...payload.value,
    password: MD5(payload.value.password).toString(),
  })
    .then((response) => {
      const { success, data, message } = response;
      if (success) {
        setUser(data)
          .then(() => {
            fecthProfile();
          })
          .catch(() => {
            toast({ message: t("error.default"), type: "error" });
          });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

onMounted(() => {
  if (store.getters.logged) goTo("/home");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require('@/assets/images/logo.png')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", null, "ADMIN | " + _toDisplayString(_unref(t)("common.labels.login").toUpperCase()), 1),
        _createElementVNode("form", {
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (sendLogin()), ["prevent"]))
        }, [
          _createVNode(_unref(baseInput), {
            modelValue: payload.value.login,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.login) = $event)),
            placeholder: _unref(t)('common.placeholders.login'),
            background: "#f1f1f1",
            maxLength: "50"
          }, _createSlots({
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.labels.login")), 1)
            ]),
            sufix: _withCtx(() => [
              _createVNode(_unref(svgIcon), {
                icon: "person",
                size: "1.5rem"
              })
            ]),
            _: 2
          }, [
            (error.value.login)
              ? {
                  name: "error",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.value.login), 1)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "placeholder"]),
          _createVNode(_unref(baseInput), {
            modelValue: payload.value.password,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payload.value.password) = $event)),
            placeholder: _unref(t)('common.placeholders.password'),
            type: passwordShow.value ? 'text' : 'password',
            background: "#f1f1f1",
            maxLength: "50"
          }, _createSlots({
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.labels.password")), 1)
            ]),
            sufix: _withCtx(() => [
              (passwordShow.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "pointer",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (passwordShow.value = false))
                  }, [
                    _createVNode(_unref(svgIcon), {
                      icon: "eye",
                      size: "1.5rem"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "pointer",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (passwordShow.value = true))
                  }, [
                    _createVNode(_unref(svgIcon), {
                      icon: "eye-closed",
                      size: "1.5rem"
                    })
                  ]))
            ]),
            _: 2
          }, [
            (error.value.password)
              ? {
                  name: "error",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.value.password), 1)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "placeholder", "type"]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", _hoisted_7, _toDisplayString(_unref(t)("common.labels.enter")?.toUpperCase()), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-none font-bold color-text-medium",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (goTo('/auth/recover')))
              }, _toDisplayString(_unref(t)("common.texts.recover_password")) + "! ", 1)
            ])
          ])
        ], 32)
      ])
    ])
  ]))
}
}

})